import { render, staticRenderFns } from "./FinishedDataTable.vue?vue&type=template&id=4006ad4a"
import script from "./FinishedDataTable.vue?vue&type=script&lang=js"
export * from "./FinishedDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports